export default __webpack_public_path__ + "static/media/ais_top_logo@2x.9ab5a4f5.webp";